// extracted by mini-css-extract-plugin
export default {"root":"AmenitiesSelect_root__T+a6z","input":"AmenitiesSelect_input__1MTo7"};